import {
  FilterId
} from '../const';
import {
  pushHistoryState
} from './params';

export class Subs {

  constructor(parent) {
    this._id = parent.dataset.id;
    this._blockContainer = parent.querySelector('.block-filter__container');
    this._blockList = this._blockContainer.querySelector('.block-filter__list');
    this._blockItems = this._blockList.querySelectorAll('.block-filter__item');
    this._subContainer = parent.querySelector('.sub-filter__container');
    this._subList = this._subContainer.querySelector('.sub-filter__list');

    this._set = null;

    this.init();
  }

  init() {
    const values = this._collectValues();
    this._set = this._createSet(values);
    this._add();
    this._checkParams();
  }

  getList() {
    return this._subList;
  }

  getCount() {
    const subs = this._getItems();
    const items = Array.from(subs).filter(sub => this._getStatusBySub(sub));
    return items.length;
  }

  active(sub) {
    sub.querySelector('.sub-filter__status').classList.toggle('checked');

    this._updateParams();
    this._checkedInputs(Array.from(this._blockItems), false);
    this._activeInputs();
  }

  removeParam() {
    const url = new URL(window.location.href);
    url.searchParams.delete(this._id);
    pushHistoryState(url);
  }

  _activeInputs() {
    const subs = this._getActiveSubValues();

    const items = Array.from(this._blockItems).filter(item => {
      const label = item.querySelector('.control__label');
      const value = this._getValue(label);
      const array = value.match(/\d+/g);
      return this._insideRange(subs, array);
    });

    this._checkedInputs(items, true);
  }

  _insideRange(checkedSubsArray, array) {
    const subs = checkedSubsArray.map((it) => Number(it));
    const inputs = array.map((it) => Number(it));
    return subs.some(t => t >= inputs[0] && t <= inputs[inputs.length - 1]);
  }

  _checkedInputs(items, bool) {
    items.forEach(it => (it.querySelector('input').checked = bool));
  }

  _getStatusBySub(elem) {
    return elem.querySelector('.sub-filter__status').classList.contains('checked');
  }

  _checkParams() {
    const url = new URL(window.location.href);
    const param = url.searchParams.getAll(this._id);
    if (param.length > 0) {
      const subs = this._getItems();
      const items = Array.from(subs).filter(sub => param.includes(this._getValue(sub)));
      items.forEach(it => it.querySelector('.sub-filter__status').classList.add('checked'));
    }
  }

  _updateParams() {
    const array = this._getActiveSubValues();

    const url = new URL(window.location.href);
    url.searchParams.delete(this._id);

    array.forEach(value => url.searchParams.append(this._id, value));

    pushHistoryState(url);
  }

  _collectValues() {
    return Array.from(this._blockItems).filter(it => !it.classList.contains('uf_hide')).map(item => item.querySelector('.control__label')).map(label => this._getValue(label));
  }

  _createSet(data) {
    const array = this._createArray(data);
    return new Set(array);
  }

  _createArray(array) {
    return array.reduce((sum, it) => {
      const arr = it.match(/\d+/g);
      const numbers = arr.map((a) => Number(a));
      const result = this._createArrayFromRange(numbers);
      return sum.concat(result);
    }, []);
  }

  _createArrayFromRange(array) {
    let i = array[0];
    let result = [];

    do {
      if (this._id === FilterId.CLOTHES) {
        if (i % 2 === 0) {
          result.push(i);
        }
      } else {
        result.push(i);
      }
      i++;
    } while (i <= array[array.length - 1]);
    return result;
  }

  _add() {
    this._clearList();

    let fragment = document.createDocumentFragment();

    Array.from(this._set).forEach((value) => {
      let item = this._createSub(value);
      fragment.appendChild(item);
    });

    this._subList.appendChild(fragment);
  }

  _createSub(value) {
    const template = document.querySelector('#sub-filter-data').content.querySelector('.sub-filter__item');
    const cloneTemplate = template.cloneNode(true);

    cloneTemplate.querySelector('.sub-filter__name').textContent = value;

    return cloneTemplate;
  }

  _clearList() {
    this._subList.innerHTML = '';
  }

  _getItems() {
    return this._subList.children;
  }

  _getActiveSubValues() {
    const subs = this._getItems();
    return Array.from(subs).filter(sub => sub.querySelector('.sub-filter__status').classList.contains('checked')).map(sub => this._getValue(sub));
  }

  _getValue(elem) {
    return elem.textContent.trim();
  }

}
